export default __webpack_public_path__ + "static/media/atos-originlogo.0cf435cf.svg";